import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MenuIcon from '@material-ui/icons/Menu';
import deepOrange from '@material-ui/core/colors/deepOrange';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

import { Avatar } from '@material-ui/core';
import { drawerWidth } from './SideBar';

const styles = theme => ({
	appBar: {
		transition: theme.transitions.create(['margin', 'width'], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen,
		}),
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		flexDirection: 'row',
	},
	appBarShift: {
		width: `calc(100% - ${drawerWidth}px)`,
		marginLeft: drawerWidth,
		transition: theme.transitions.create(['margin', 'width'], {
			easing: theme.transitions.easing.easeOut,
			duration: theme.transitions.duration.enteringScreen,
		}),
	},
	menuButton: {
		marginLeft: 12,
		marginRight: 20,
	},
	avatar: {
		margin: '0 24px',
		cursor: 'pointer',
		backgroundColor: `${deepOrange[500]}`,
	},
	logo: {
		'& a': {
			textDecoration: 'none',
			color: `${theme.palette.grey['200']}`,
		},
	},
});

const getProfileName = profile => {
	const { given_name, family_name } = profile;
	if (given_name && family_name) {
		return `${given_name[0]}${family_name[0]}`;
	}
	return '';
};

class Navbar extends React.Component {
	state = {
		userMenu: null,
	};

	handleClick = event => {
		this.setState({ userMenu: event.currentTarget });
	};

	handleClose = () => {
		this.setState({ userMenu: null });
	};

	render() {
		const { classes, open, handleDrawer, profile, auth } = this.props;
		const { userMenu } = this.state;

		return (
			<AppBar
				position="fixed"
				className={classNames(classes.appBar, {
					[classes.appBarShift]: open,
				})}
			>
				<Toolbar disableGutters={!open}>
					<IconButton
						color="inherit"
						aria-label="Open drawer"
						onClick={handleDrawer}
						className={classes.menuButton}
					>
						<MenuIcon />
					</IconButton>
					<Typography variant="h6" color="inherit" noWrap className={classes.logo}>
						<Link to="/">Dashboard App</Link>
					</Typography>
				</Toolbar>
				<Avatar
					aria-owns={userMenu ? 'user-menu' : undefined}
					aria-haspopup="true"
					onClick={this.handleClick}
					className={classes.avatar}
				>
					{getProfileName(profile)}
				</Avatar>
				<Menu
					id="user-menu"
					anchorEl={userMenu}
					open={Boolean(userMenu)}
					onClose={this.handleClose}
				>
					<MenuItem onClick={() => auth.logout()}>Logout</MenuItem>
				</Menu>
			</AppBar>
		);
	}
}

export default withStyles(styles, { withTheme: true })(Navbar);
